import { OrderDirection } from "common/contracts/order-direction";
import PaginationParameters from "common/contracts/pagination-parameters";

export class ForumFilterParameters {
  name?: string;
  entityId?: string;
  entityClass?: string;
  context?: string;
  subscriberId?: string;
  minCreatedDate?: Date;
  maxCreatedDate?: Date;
  systemOnly?: boolean;
  forumId?: string;

  public asSearchParams(): URLSearchParams {
    const searchParams = new URLSearchParams();
    if (this.name) searchParams.append("name", this.name);
    if (this.entityId) searchParams.append("entityId", this.entityId);
    if (this.entityClass) searchParams.append("entityClass", this.entityClass);
    if (this.context) searchParams.append("context", this.context);
    if (this.subscriberId) searchParams.append("subscriberId", this.subscriberId);
    if (this.minCreatedDate) searchParams.append("minCreatedDate", this.minCreatedDate.toISOString());
    if (this.maxCreatedDate) searchParams.append("maxCreatedDate", this.maxCreatedDate.toISOString());
    if (this.systemOnly) searchParams.append("systemOnly", this.systemOnly.toString());
    if (this.forumId) searchParams.append("forumId", this.forumId);
    return searchParams;
  }

  public isEqualTo(other: ForumFilterParameters): boolean {
    if (!other) return false;
    return this.name === other.name &&
      this.entityId === other.entityId &&
      this.entityClass === other.entityClass &&
      this.context === other.context &&
      this.subscriberId === other.subscriberId &&
      this.minCreatedDate?.getTime() === other.minCreatedDate?.getTime() &&
      this.maxCreatedDate?.getTime() === other.maxCreatedDate?.getTime() &&
      this.systemOnly === other.systemOnly &&
      this.forumId === other.forumId;
  }
}

export class ForumOrderParameters {
  orderBy?: ForumOrderField;
  orderDir?: OrderDirection;

  constructor(orderBy?: ForumOrderField, orderDir?: OrderDirection) {
    this.orderBy = orderBy;
    this.orderDir = orderDir;
  }

  public isEqualTo(other: ForumOrderParameters): boolean {
    if (!other) return false;
    return this.orderBy === other.orderBy &&
      this.orderDir === other.orderDir;
  }

  public asSearchParams(): URLSearchParams {
    const searchParams = new URLSearchParams();
    if (this.orderBy) searchParams.append("orderBy", this.orderBy);
    if (this.orderDir) searchParams.append("orderDir", this.orderDir);
    return searchParams;
  }
}

export enum ForumOrderField {
  CreatedDate = "CreatedDate",
  Name = "Name",
  EntityId = "EntityId",
  EntityClass = "EntityClass",
  Context = "Context"
}

export default class QueryForumsApiRequest {
  public query?: string;
  public filterParameters: ForumFilterParameters;
  public orderParameters: ForumOrderParameters;
  public paginationParameters: PaginationParameters;

  constructor(
    filterParameters: ForumFilterParameters,
    orderParameters: ForumOrderParameters,
    paginationParameters: PaginationParameters,
    query?: string
  ) {
    this.query = query;
    this.filterParameters = filterParameters;
    this.orderParameters = orderParameters;
    this.paginationParameters = paginationParameters;
  }

  public asSearchParams(): URLSearchParams {
    return new URLSearchParams([
      ["query", this.query ?? ""],
      ...this.filterParameters.asSearchParams(),
      ...this.orderParameters.asSearchParams(),
      ...this.paginationParameters.asSearchParams()
    ]);
  }

  public isEqualTo(other: QueryForumsApiRequest): boolean {
    if (!other) return false;
    return this.query === other.query &&
      this.filterParameters.isEqualTo(other.filterParameters) &&
      this.orderParameters.isEqualTo(other.orderParameters) &&
      this.paginationParameters.isEqualTo(other.paginationParameters);
  }
}
